// extracted by mini-css-extract-plugin
export default {"errorPage":"axnui-error-page__error-page__mbNNy","asi":"axnui-error-page__asi__qlsYu","errorDescription":"axnui-error-page__error-description___0qna"};